function calculateDuration(totalWidth) {
  const desiredSpeed = 50;
  const duration = (totalWidth / desiredSpeed) * 1000;
  return duration;
}

function initLoop(selectorOrElement, direction = 'left-to-right') {
  let loop;
  if (typeof selectorOrElement === 'string') {
    loop = document.querySelector(selectorOrElement);
  } else if (selectorOrElement instanceof Element) {
    loop = selectorOrElement;
  } else {
    console.warn('Invalid argument passed to initLoop');
    return;
  }

  if (!loop) {
    console.warn(`Element with selector "${selectorOrElement}" not found.`);
    return;
  }

  checkSpaceTop(loop);
  window.addEventListener('resize', function() {
    checkSpaceTop(loop);
  });

  const messageItems = loop.querySelectorAll('[data-message-item]');
  const itemsCount = messageItems.length;
  const itemWidth = messageItems[0].offsetWidth;
  let totalWidth = itemWidth * itemsCount;
  let totalItem = itemsCount;

  while (totalWidth < 5000) {
    const clonedItems = Array.from(messageItems).map(item => item.cloneNode(true));
    clonedItems.forEach(item => loop.appendChild(item));
    totalWidth += itemWidth * itemsCount;
    totalItem += 1;
  }

  const duration = calculateDuration(totalWidth);

  loop.style.width = `${totalWidth}px`;
  const loopAnim = new TimelineMax({ repeat: -1, paused: true });

  if (direction === 'left-to-right') {
    loopAnim.to(loop, {
      x: `50%`,
      duration: duration / 1000,
      ease: 'none'
    });
  } else {
    loopAnim.to(loop, {
      x: `-50%`,
      duration: duration / 1000,
      ease: 'none'
    });
  }

  loop.addEventListener("mouseenter", () => loopAnim.pause());
  loop.addEventListener("mouseleave", () => loopAnim.play());
  loop.addEventListener("touchstart", () => loopAnim.pause());
  loop.addEventListener("touchend", () => loopAnim.play());
  loopAnim.play();
}

function checkSpaceTop(loop) {
  const messageContainer = loop.closest('[data-message-container]');
  const messageBox = loop.closest('[data-message-box]');
  
  const mt = messageContainer.getBoundingClientRect().height - messageContainer.clientHeight;
  messageBox.style.setProperty('--mss-height-box', messageContainer.getBoundingClientRect().height + 'px');
  messageBox.style.setProperty('--mss-mt-box', mt + 'px');
}

document.addEventListener("DOMContentLoaded", () => {
  const loopElements = document.querySelectorAll('[data-message-list]');
  loopElements.forEach(loopElement => {
    const direction = loopElement.closest('[data-message-box]').getAttribute('data-direction');
    initLoop(loopElement, direction);
  });
});